<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <error-msg-component
        :error="error"
        :messages="messages"
        @close="error = $event"
        title="general.problemOccurred"
        withEmplyFields
      />
      <section class="has-text-centered">
        <b-icon type="is-warning" icon="alert-outline" class="icon-modal"></b-icon>
        <p class="is-size-5 has-text-weight-bold">
          {{ messHeader }}
        </p>
      </section>
      <main>
        <br>
        <b-field :label="$t('dispositifPublicitaire.popUpSave.date')">
          <b-datepicker v-model="date"
              :placeholder="$t('dispositifPublicitaire.popUpSave.date')">
          </b-datepicker>
       </b-field>
        <b-field :label="$t('dispositifPublicitaire.popUpSave.commentaire')">
          <textarea class="textarea"
            rows="2"
            v-model="commentaire">
          </textarea>
       </b-field>
      <b-field>
            <b-checkbox v-model="ischeckboxed">
               {{ $t('dispositifPublicitaire.popUpSave.modifierEtatMontage') }}
            </b-checkbox>
        </b-field>
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered mg-button-modal"
            @click="$parent.close">
            {{ $t(cancel) }}
          </button>
          <button
            class="button is-warning has-text-centered mg-button-modal"
            @click="sendUpdate()">
            {{ $t(validate) }}
          </button>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { changerEtat } from '@/api/gabed/dispositif';
import formatDate from '@/services/general/formatIsoDate';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationDispositif from '@/services/gabed/dispositif/validation';
import messageErreur from '@/services/general/messageErreur';

export default {
  name: 'popUpUpdateEtat',
  data() {
    return {
      ischeckboxed: true,
      date: null,
      messages: [],
      error: null,
      commentaire: null,
    };
  },
  props: {
    messHeader: String,
    cancel: {
      type: String,
      default: 'general.non',
    },
    validate: {
      type: String,
      default: 'general.oui',
    },
    dispositifs: {
      type: Array,
      required: true,
    },
    etat: {
      type: String,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
  },
  methods: {
    async sendUpdate() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.dispositifIds = this.dispositifs.map((el) => el.id);
        await changerEtat({
          dispositifIds: this.dispositifIds,
          synchroEtatPatrimoine: this.ischeckboxed,
          nouvelEtat: this.etat,
          dateUpdateEtat: formatDate(this.date),
          commentaire: this.commentaire,
        });
        this.messages = [];
        this.$emit('validate');
      } catch (e) {
        if (e.response?.data?.error) {
          validationDispositif(e.response, this.messages);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
  },
};
</script>

<style scoped>

</style>
